import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewEncapsulation
} from '@angular/core';
import { UserService } from '@emm/core/services/user.service';
import { Screen } from '@emm/core/models/screen.model';


@Component({
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'emm-screen-selector',
    styleUrls: ['./screen-selector.component.scss'],
    templateUrl: './screen-selector.component.html',
    standalone: false
})
export class ScreenSelectorComponent implements OnInit {

    @Input() screens: Screen[];

    @Output() screenSelected = new EventEmitter<Screen>();
    selected;
    nestedScreens: Screen[];
    filteredScreens: Screen[];
    isAdmin = false;
    isSuperAdmin = false;
    isAuthor = false;
    isMMSAuthor = false;
    isReadOnly = false;

    constructor(private userService: UserService) {
        this.isAdmin = this.userService.hasAdminRole();
        this.isSuperAdmin = this.userService.hasSuperAdminRole();
        this.isAuthor = this.userService.hasAuthorRole();
        this.isMMSAuthor = this.userService.hasMMSAuthorRole();
        this.isReadOnly = this.userService.hasLoginRole();
    }

    ngOnInit(): void {
        if (window.location.pathname.includes('management')) {
            this.filterManagementScreens();
            try {
                const screen = JSON.parse(localStorage.getItem('managementScreen'));
                this.onScreenSelected(screen ? screen : this.screens[0]);
            } catch (e) {
                this.onScreenSelected(this.screens[0]);
            }
        } else {
            try {
                const screen = JSON.parse(localStorage.getItem('reportsScreen'));
                this.onScreenSelected(screen ? screen : this.screens[0]);
            } catch (e) {
                this.onScreenSelected(this.screens[0]);
            }
        }
        this.filterScreensByRole();
    }

    filterManagementScreens() {
        this.nestedScreens = [this.screens[1], this.screens[3], this.screens[4], this.screens[6], this.screens[8],
            this.screens[9], this.screens[11], this.screens[12]];

        // Filters the screens array to only render valid top level screens
        this.filteredScreens = this.screens.filter((screen) => !this.nestedScreens.includes(screen));
    }

    filterScreensByRole() {
        if (this.isReadOnly || this.isAuthor) {
            this.filteredScreens = this.filteredScreens?.filter((screen) =>
                (screen.name ? screen.name !== 'Master Menu System' : screen.route ? !screen.route.includes('MMS')
                    : false) && screen.route !== 'operations');
        }
        if (this.isMMSAuthor) {
            // MMS Author should only keep Master Menu System routes (both MMS Revote and MMS Admin Override)
            this.filteredScreens = this.filteredScreens?.filter((screen) =>
                screen.route === 'mms-revote' || screen.route === 'mms-admin-override');
        }
    }

    onScreenSelected(screen: Screen): void {
        this.selected = screen;
        this.screenSelected.emit(screen);
        // This caused a bug with locales select, so I'm reverting it. We should fix this in the future.
        // this.router.events
        //     .pipe(filter(event => event instanceof NavigationEnd))
        //     .subscribe(() => {
        //         this.selected = screen;
        //         this.screenSelected.emit(screen);
        //     });
    }

    isPanelExpanded(screen: Screen): boolean {
        let result: boolean;
        screen.children.find(child => child.selected) ? result = true : result = false;
        return result;
    }
}
